import React, { useState } from "react";
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Form, Header, TextArea, Input, Button, Popup, Icon } from "semantic-ui-react";
import { NumericFormat } from 'react-number-format';
import { SearchCodparcAction, CriarVitrineAction } from '../../../actions/EspacoTecaActions';
import KanbanDndKit from "./KanbanDndKit";

function Vitrine({ navigateToVitrine, ...props }) {
    const { isSearchingCodparc, urlsVitrine, userid, isLoadingCriaVitrine } = props;
    const { SearchCodparcAction, CriarVitrineAction } = props;

    const [observacao, setObservacao] = useState("");
    const [codparcSearch, setCodparc] = useState("0");
    const [nomeParc, setNomeParc] = useState(codparcSearch == 0 ? "Cliente Anônimo" : "");
    const [codparcMessage, setCodparcMessage] = useState("");
    const [copGuid, setCopGuid] = useState("");
    const [errorSaving, setErrorSaving] = useState([]);
    const [blocosData, setBlocosData] = useState([]);
    const maxLength = 100;

    const handleSearchCodparc = () => {
        if (codparcSearch !== '') {
            const codparc = parseInt(codparcSearch);
            if (codparc !== 0) {
                SearchCodparcAction(codparc).then((dados) => {
                    console.log(dados)
                    setNomeParc(dados?.[0]?.nomeparc || '');
                    setCodparcMessage(dados?.[0]?.message || '');
                    setErrorSaving([]);
                });
            } else {
                setNomeParc('Cliente Anônimo');
            }
        } else {
            setNomeParc('Cliente Anônimo');
            setCodparc(0);
        }
    }

    const handleCriarVitrine = () => {
        let listError = [];

        if (codparcMessage === 'Parceiro não encontrado') {
            listError.push({ codparcSearch: codparcSearch, campo: 'codparc' });
        }
        if (observacao === '') {
            listError.push({ observacao: observacao, campo: 'observacao' });
        }

        setErrorSaving(listError);

        const itensVitrine = blocosData.flatMap((bloco, blocoIndex) =>
            bloco.imagens.map((img, imgIndex) => ({
                url: img.url,
                posicao: imgIndex + 1,
                bloco: bloco.sku,
                posicaoBloco: blocoIndex + 1
            })),
        );
        const dadosVitrine = {
            observacao: observacao,
            userid: userid,
            codparc: codparcSearch,
            itens: JSON.stringify(itensVitrine)
        };
        if (observacao != '') {
            CriarVitrineAction(dadosVitrine).then((url) => {
                console.log(url)
                setCopGuid(url[0].url)
            })
        }


        console.log(dadosVitrine);
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(copGuid)
            .then(() => alert("Link copiado!"))
            .catch(err => console.error("Erro ao copiar: ", err));
    };

    return (
        <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "3rem", marginTop: "1rem", position: "relative" }}>
                <Header as="h2" style={{ position: "absolute", left: "50%", transform: "translateX(-50%)" }}>
                    Nova Vitrine
                </Header>
            </div>

            <div style={{ display: "flex", gap: "2rem" }}>
                <div style={{ flex: 2 }}>
                    <Form style={{ width: '600px' }}>
                        <Form.Group>
                            <Form.Field width={4}>
                                <label>
                                    Parceiro{" "}
                                    <Popup
                                        content='Caso queira criar para cliente anônimo basta deixar o campo "Parceiro" com valor 0'
                                        trigger={<Icon name='info circle' style={{ color: '#2185d0', cursor: 'pointer' }} />}
                                    />
                                </label>
                                <NumericFormat
                                    placeholder="Codparc"
                                    name="codparc"
                                    customInput={Input}
                                    allowLeadingZeros={false}
                                    value={codparcSearch}
                                    onValueChange={(values) => {
                                        if (codparcSearch === "0" && values.value !== "0") {
                                            setCodparc(values.value.replace(/^0+/, ""));
                                        } else {
                                            setCodparc(values.value);
                                        }
                                    }}
                                    loading={isSearchingCodparc}
                                    onBlur={handleSearchCodparc}
                                />
                            </Form.Field>

                            <Form.Field width={12}>
                                <label>Nome do parceiro</label>
                                <div style={{ borderBottom: "1px solid #000", minHeight: "35px", display: "flex", alignItems: "flex-end", padding: "4px 8px" }}>
                                    {nomeParc}
                                </div>
                            </Form.Field>
                        </Form.Group>

                        <Form.Field error={errorSaving.some(a => a.campo === 'observacao' && (!a.observacao || a.observacao === ''))}>
                            <label>Observações</label>
                            <TextArea
                                value={observacao}
                                maxLength={maxLength}
                                onChange={(e) => setObservacao(e.target.value)}
                                placeholder="Digite suas observações..."
                                style={{ resize: "none" }}
                            />
                            <div style={{ textAlign: "right", marginTop: "4px", fontSize: "12px", color: "#666" }}>
                                {observacao.length}/{maxLength}
                            </div>
                        </Form.Field>
                    </Form>
                </div>

                <div style={{ flex: 1, padding: "1rem", display: "flex", flexDirection: "column", justifyContent: "flex-start", gap: "1rem" }}>
                    <Button color="green" onClick={handleCriarVitrine} loading={isLoadingCriaVitrine}>Criar Vitrine</Button>

                    <Form.Field>
                        <label>Link da vitrine</label>
                        <div style={{ borderBottom: "1px solid #000", minHeight: "35px", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "4px 8px", wordBreak: "break-all" }}>
                            <span>{copGuid}</span>
                            <Icon name="copy" link onClick={copyToClipboard} style={{ marginLeft: "8px" }} />
                        </div>
                    </Form.Field>
                </div>
            </div>

            {/* KanbanDndKit */}
            <KanbanDndKit blocosVitrine={urlsVitrine} onChange={setBlocosData} navigateToVitrine={navigateToVitrine} />

        </>
    );
}

const mapStateToProps = (state) => ({
    isSearchingCodparc: state.EspacoTecaReducer.isSearchingCodparc,
    urlsVitrine: state.EspacoTecaReducer.urlsVitrine,
    userid: state.LoginReducer.userid,
    isLoadingCriaVitrine: state.EspacoTecaReducer.isLoadingCriaVitrine
});

export default withRouter(connect(mapStateToProps, { SearchCodparcAction, CriarVitrineAction })(Vitrine));
